import React from 'react';
import { useTranslation } from 'react-i18next';

import { TaskStatus } from '@/services/ws-funnel/src/main/resources/rest-api';
import { Badge, Icons, Tooltip } from '@/js/libs/ui/src/V2';

import type { ColumnProps } from '../../types';

export const StatusCell: React.FC<ColumnProps> = React.memo(function StatusCell({ item }) {
  const [t] = useTranslation(['backend', 'serviceDashboard']);

  const tooltip = item.outcome ? t(item.outcome, { ns: 'serviceDashboard' }) : undefined;
  const icon = React.useMemo(() => {
    switch (item.status) {
      case TaskStatus.DONE:
        return <Icons.Check size={16} />;
      case TaskStatus.IN_PROGRESS:
        return <Icons.Spinner size={16} />;
      case TaskStatus.NEW:
        return <Icons.PersonAdd size={16} />;
      case TaskStatus.ARCHIVED:
        return <Icons.Archived size={16} />;
      case TaskStatus.SNOOZED:
        return <Icons.Clock size={16} />;
      default:
        return undefined;
    }
  }, [item.status]);

  if (!item.status) {
    return null;
  }

  return (
    <Tooltip trigger='hover' placement='top' tooltip={tooltip} disabled={!item.outcome}>
      <Badge
        title={t(item.status, { ns: 'serviceDashboard' })}
        icon={icon}
        positive={item.status === TaskStatus.DONE}
        warning={item.status === TaskStatus.IN_PROGRESS}
        informative={item.status === TaskStatus.NEW}
        // TODO: add new color for SNOOZED status, for now both ARCHIVED and SNOOZED is gray
      />
    </Tooltip>
  );
});
